// components/qualificacao/regras.js — o vocabulário da qualificação do lead
// (out/26, rastreamento PR 2).
//
// As MESMAS chaves e frases de backend/app/services/qualificacao_lead.py
// (STATUS, MOTIVOS): o servidor é a autoridade, aqui só se repete pra tela
// desenhar sem pedir. Mudou lá, muda aqui.

export const STATUS = {
  qualificado: {
    rotulo: 'Qualificado', curto: 'Qualificado', dica: 'Tem perfil e interesse',
    bg: 'var(--ch-green-bg)', cor: 'var(--ch-green-d)', borda: 'var(--ch-green-b)', ponto: 'var(--ch-green)',
  },
  desqualificado: {
    rotulo: 'Desqualificado', curto: 'Desqualificado', dica: 'Escolha o motivo',
    bg: 'var(--ch-red-bg)', cor: 'var(--ch-red-d)', borda: 'var(--ch-red-b)', ponto: 'var(--ch-red)',
  },
  venda: {
    rotulo: 'Venda fechada', curto: 'Venda', dica: 'Informe o valor',
    bg: 'var(--ch-blue-bg)', cor: 'var(--ch-blue-d)', borda: 'var(--ch-blue-b)', ponto: 'var(--ch-blue)',
  },
};

export const ORDEM = ['qualificado', 'desqualificado', 'venda'];

// Mesma ordem do menu no servidor. Chave nova entra no FIM.
export const MOTIVOS = [
  ['sem_perfil', 'Sem perfil'],
  ['sem_orcamento', 'Sem orçamento'],
  ['curiosidade', 'Só curiosidade'],
  ['regiao', 'Região não atendida'],
  ['spam', 'Spam ou número errado'],
  ['outro', 'Outro'],
];
export const MOTIVO_TEXTO_MAX = 200;

// A tela oferece "Desfazer" por 10 s (o servidor aceita por 60, folga de
// rede e de quem demora pra clicar).
export const DESFAZER_MS = 10000;

const BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
export const formatarValor = (v) => (v == null ? '' : BRL.format(Number(v)));

// "1.250,00", "1250,5", "1250.50", "R$ 99" → número; vazio ou lixo → null.
// Ponto seguido de 3 dígitos é milhar ("1.250"); senão, decimal ("99.9").
export function lerValor(texto) {
  let t = String(texto ?? '').replace(/[R$\s]/g, '');
  if (!t) return null;
  if (t.includes(',')) t = t.replace(/\./g, '').replace(',', '.');
  else if (/^\d{1,3}(\.\d{3})+$/.test(t)) t = t.replace(/\./g, '');
  if (!/^\d+(\.\d{1,2})?$/.test(t)) return null;
  const n = Number(t);
  return Number.isFinite(n) && n > 0 ? n : null;
}

// A frase curta do que está marcado: "Desqualificado · Sem orçamento",
// "Venda fechada · R$ 1.250,00".
export function descrever(q) {
  if (!q?.status || !STATUS[q.status]) return '';
  const base = STATUS[q.status].rotulo;
  if (q.status === 'desqualificado') {
    const m = q.motivo === 'outro' && q.motivo_texto ? q.motivo_texto : q.motivo_rotulo;
    return m ? `${base} · ${m}` : base;
  }
  if (q.status === 'venda' && q.valor != null) return `${base} · ${formatarValor(q.valor)}`;
  return base;
}
